<div class="dashboard-container">
  <!-- Header -->
  <div class="dashboard-header">
    <!-- <h1>Dashboard</h1> -->
    <button mat-fab (click)="refreshData()" [matTooltip]="'dashboard.refresh_tooltip' | translate" [disabled]="isLoading" class="icon-rounded">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ 'dashboard.loading' | translate }}</p>
  </div>

  <!-- Error message -->
  <div *ngIf="errorKey" class="error-message">
    <mat-icon color="warn">error_outline</mat-icon>
    <span>{{ errorKey | translate }}</span>
  </div>

  <!-- Stats Cards -->
  <div class="stats-cards" *ngIf="!isLoading">
    <!-- Operators Card -->
    <mat-card class="stat-card" [class.card-active]="operatorCount > 0">
      <mat-card-header  class="no-padding header-spacings">
        <div mat-card-avatar class="stat-avatar operators">
          <mat-icon>people_alt</mat-icon>
        </div>
        <mat-card-title>{{ operatorCount }}</mat-card-title>
        <mat-card-subtitle>{{ 'dashboard.operators_label' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <!-- <mat-card-content>
        <div class="stat-value">{{ operatorCount }}</div>
        <div class="stat-label">Operatori registrati</div>
      </mat-card-content> -->
    </mat-card>

    <!-- Devices Card -->
    <mat-card class="stat-card" [class.card-active]="deviceCount > 0">
      <mat-card-header class="no-padding header-spacings">
        <div mat-card-avatar class="stat-avatar devices">
          <mat-icon>devices</mat-icon>
        </div>
        <mat-card-title>{{ deviceCount }}</mat-card-title>
        <mat-card-subtitle>{{ 'dashboard.devices_label' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <!-- <mat-card-content>
        <div class="stat-value">{{ deviceCount }}</div>
        <div class="stat-label">Dispositivi registrati</div>
      </mat-card-content> -->
    </mat-card>

    <!-- Technicians Card -->
    <mat-card class="stat-card" [class.card-active]="technicianCount > 0">
      <mat-card-header  class="no-padding header-spacings">
        <div mat-card-avatar class="stat-avatar technicians">
          <mat-icon>engineering</mat-icon>
        </div>
        <mat-card-title>{{ technicianCount }}</mat-card-title>
        <mat-card-subtitle>{{ 'dashboard.technicians_label' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <!-- <mat-card-content>
        <div class="stat-value">{{ technicianCount }}</div>
        <div class="stat-label">Tecnici registrati</div>
      </mat-card-content> -->
    </mat-card>
  </div>

  <!-- Tables Section -->
  <div class="tables-container" *ngIf="!isLoading">
    <!-- Rooms Table -->
    <div class="table-section m-b-32">
      <h2 class="m-b-16">{{ 'dashboard.available_rooms_title' | translate }}</h2>
      <div class="table-container">
        <table mat-table [dataSource]="rooms" class="mat-elevation-z1">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.room_name_header' | translate }}</th>
            <td mat-cell *matCellDef="let room">
              {{ room.name || ('dashboard.not_available' | translate) }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.room_status_header' | translate }}</th>
            <td mat-cell *matCellDef="let room">
              <span class="status-badge" [ngClass]="getRoomStatusClass(room)">
                {{ getRoomStatusLabelKey(room) | translate }}
              </span>
            </td>
          </ng-container>

          <!-- Participants Column -->
          <ng-container matColumnDef="participants">
            <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.room_participants_header' | translate }}</th>
            <td mat-cell *matCellDef="let room">
              <span *ngIf="room.participants !== undefined">
                {{ room.participants }}
              </span>
              <span *ngIf="room.participants === undefined">{{ 'dashboard.not_available' | translate }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="roomsColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: roomsColumns;"></tr>
        </table>
      </div>
    </div>

    <!-- Devices Table -->
    <div class="table-section">
      <h2  class="m-b-16">{{ 'dashboard.registered_devices_title' | translate }}</h2>
      <div class="table-container">
        <table mat-table [dataSource]="devices" class="mat-elevation-z1">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.device_name_header' | translate }}</th>
            <td mat-cell *matCellDef="let device">
              {{ device.name || ('dashboard.not_available' | translate) }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.device_status_header' | translate }}</th>
            <td mat-cell *matCellDef="let device">
              <span class="status-badge" [class.online]="device.status === 'online'">
                {{ device.status === 'online' ? ('dashboard.device_status_online' | translate) : ('dashboard.device_status_offline' | translate) }}
              </span>
            </td>
          </ng-container>

          <!-- Last Seen Column -->
          <ng-container matColumnDef="lastSeen">
            <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.device_last_seen_header' | translate }}</th>
            <td mat-cell *matCellDef="let device">
              {{ device.lastSeen ? (device.lastSeen | date:'dd/MM/yyyy HH:mm') : ('dashboard.not_available' | translate) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="devicesColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: devicesColumns;"></tr>

          <!-- Empty state -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell p-16 text-muted" [attr.colspan]="devicesColumns.length">
              {{ 'dashboard.no_devices' | translate }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
